import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/api/global.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import SwalAlert from 'src/app/utils/swalalert';
import AlertifyHelper from 'src/app/utils/utils';
import * as moment from 'moment';
import { ExpenseService } from 'src/app/api/money/expense.service';
declare var $: any;

@Component({
  selector: 'app-expense-list',
  templateUrl: './expense-list.component.html',
  styleUrls: ['./expense-list.component.css']
})
export class ExpenseListComponent implements OnInit{
  private thisComponent: ExpenseListComponent;
  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  @ViewChild(SearchComponent) searchComponent: any;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  // variables
  start_range:any = moment().startOf('month');
  end_range:any = moment().endOf('month');

  constructor(
    private router: Router,
    private expenseService: ExpenseService,
    private globalService: GlobalService,
    private alert: SwalAlert,
    private alertifyMsg: AlertifyHelper,
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.thisComponent = this;
  }

  ngOnInit() {
    let component_ = this.thisComponent;
    (<any>$('#date_range')).daterangepicker({
      locale: {
        format: 'YYYY-MM-DD'
      },
      startDate: component_.start_range,
      endDate: component_.end_range,
      showDropdowns: true,
    },
      function(chosen_date: any) {
        // (<any>$('#date_arrival')).val( chosen_date.format('YYYY-MM-DD'));
        // component_.setDateArrival(chosen_date.format('YYYY-MM-DD'));
      }  
    );

    this.list();
  }

  list() {
    let val_params = 'search=' + this.params.search + '&page=' + this.page + '&branchofficeSlug='+this.branchofficeSlug
    "&start_range=" + this.start_range.format('YYYY-MM-DD') + '&end_range=' + this.end_range.format('YYYY-MM-DD');
    this.expenseService.list(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total;
      }
    });
  }

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.list();
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  refresh() {
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    this.list();
  }

  edit(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/turismo/ciudades/editar',
      id
    ]);
  }

  delete(item: any) {
    let options = {
      title: '¿Estás segur@ de anular el movimiento de egreso?',
      message: item.nro_voucher,
      cancel: 'Cancelar',
      confirm: 'Sí, ANULAR'
    };
    this.alert.confirmDelete(options).then((result: any) => {
      if (result.isConfirmed) {
        this.expenseService.delete(item.id).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('El registro '+item.nro_voucher+' se ha anulado con éxito');
            this.list();
          }
        });
      }
    });
  }

}

